var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondTronDaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tron-dao"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_14971)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6029,
    cy: 61,
    rx: 21.5404,
    ry: 21,
    fill: "#FF4747",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_14971)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6029,
    cy: 61,
    rx: 21.5404,
    ry: 21,
    fill: "#FF4747",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_14971)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6029,
    cy: 61,
    rx: 21.5404,
    ry: 21,
    fill: "#FF4747",
    fillOpacity: 0.78
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.1238 79.3486C60.0171 79.1413 59.9264 78.9969 59.8621 78.8411C58.9392 76.5758 58.0186 74.309 57.1006 72.0408C55.2975 67.6072 53.4945 63.1756 51.6915 58.7459C50.1467 54.9414 48.6034 51.1369 47.0616 47.3324C47.0504 47.3112 47.0406 47.2892 47.0324 47.2667C46.9768 47.0579 46.9227 46.8478 46.8672 46.6377C47.0803 46.6273 47.2939 46.6335 47.506 46.6562C49.5059 47.0136 51.5014 47.3839 53.4999 47.7441C55.7366 48.1458 57.9763 48.5375 60.213 48.9392C61.6617 49.1994 63.1061 49.4767 64.5534 49.7369C66.2404 50.0428 67.9289 50.3373 69.616 50.639C70.382 50.7819 71.1481 50.9149 71.9097 51.0678C72.0613 51.1046 72.2004 51.1795 72.3132 51.2851C74.3657 53.1836 76.4158 55.0844 78.4635 56.9876C78.6535 57.1649 78.6579 57.2964 78.4883 57.4979C74.1543 62.6586 69.8231 67.8217 65.4949 72.9871C63.8195 74.9885 62.1403 76.9822 60.4571 78.9683C60.3767 79.0741 60.2817 79.1771 60.1238 79.3486ZM59.9367 74.1322L60.039 74.1079C60.0647 74.0455 60.0843 73.9809 60.0975 73.9149C60.3353 72.0136 60.5726 70.1123 60.8094 68.211C61.1398 65.5177 61.4702 62.8259 61.7831 60.1312C61.7852 60.0419 61.7687 59.9531 61.7345 59.8702C61.7003 59.7874 61.6492 59.7122 61.5842 59.6494C61.1457 59.2549 60.6764 58.8946 60.2174 58.5215C57.0694 55.9693 53.9209 53.4185 50.772 50.8691C50.6928 50.8112 50.6103 50.7577 50.5249 50.709L50.4416 50.7719L59.9367 74.1322ZM75.1201 58.6773C74.9643 58.6665 74.808 58.6665 74.6523 58.6773C73.455 58.8875 72.2591 59.1062 71.0618 59.3178L66.6439 60.0983C65.758 60.2541 64.8721 60.4156 63.9847 60.5672C63.7216 60.6115 63.5754 60.7316 63.5461 61.0046C63.5125 61.3835 63.4555 61.7609 63.4087 62.1397C63.1972 63.8409 62.9848 65.5415 62.7713 67.2418C62.5374 69.1326 62.3045 71.0229 62.0725 72.9128C62.0199 73.3416 61.9804 73.7705 61.9351 74.1994L62.0389 74.2451L75.1201 58.6773ZM69.6028 52.6117L69.5166 52.4516L51.8976 49.2809L51.8231 49.3924C51.9269 49.4682 52.0321 49.5353 52.133 49.6226C53.0335 50.3488 53.9336 51.0769 54.8331 51.8069C57.3184 53.8211 59.8036 55.8311 62.2699 57.8596C62.5915 58.1241 62.7947 58.1012 63.1003 57.8482C65.1382 56.167 67.1936 54.503 69.2403 52.8347C69.3559 52.7525 69.477 52.678 69.6028 52.6117ZM75.4037 56.7145C75.361 56.6384 75.3121 56.5657 75.2575 56.4973C74.1406 55.4565 73.0179 54.4173 71.9024 53.3737C71.7314 53.215 71.61 53.2436 71.4375 53.3851C69.8514 54.6817 68.2579 55.9698 66.6688 57.2635C66.2068 57.6395 65.7507 58.024 65.2917 58.4071L65.3341 58.4972L75.4037 56.7145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14971",
    x: 0.762501,
    y: 0.700001,
    width: 121.682,
    height: 120.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14971",
    x: 0.762501,
    y: 0.700001,
    width: 121.682,
    height: 120.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_14971",
    x: 0.762501,
    y: 0.700001,
    width: 121.682,
    height: 120.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14971"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondTronDaoIcon);
export default __webpack_public_path__ + "static/media/SecondTronDaoIcon.48a808c78dcf6d6c50fecf34c1b4d43c.svg";
export { ForwardRef as ReactComponent };